import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import { TableChartOutlined, DescriptionOutlined, MedicationOutlined, PolicyOutlined } from '@mui/icons-material';
import { useCurrentuser } from '@uplift/contexts';
import { useL10n } from '@uplift/hooks';
import { HelpCenterContainer, HelpCenterTile } from '@uplift/pages';
import { ProviderMedicalRole } from '@uplift/types';
import { ProviderLayout, ProviderLayoutPageHeader, ProviderLayoutPageTitle } from '@uplift/ui-v2';

const PSYCHIATRY_DOCUMENTATION_GUIDE_URL = 'https://provider-help.joinuplift.co/en_us/psychiatry-uplift-clinical-documentation-provider-guide-B14cvdsxWe';
const THERAPY_DOCUMENTATION_GUIDE_URL = 'https://provider-help.joinuplift.co/en_us/therapy-uplift-clinical-documentation-provider-guide-HkeaGsgXZg';

const getProviderTiles = (documentationGuideHref: string): HelpCenterTile[] => [
  {
    title: 'CPT Coding Guide',
    description: 'Codes and modifiers for psychiatric visits.',
    icon: TableChartOutlined,
    href: 'https://provider-help.joinuplift.co/en_us/psychiatry-cpt-code-reference-guide-SyJNM0_gg',
  },
  {
    title: 'Documentation Guide',
    description: 'How to chart notes and visit summaries.',
    icon: DescriptionOutlined,
    href: documentationGuideHref,
  },
  {
    title: 'Formulary',
    description: 'Covered medications and prescribing tiers.',
    icon: MedicationOutlined,
    href: 'https://provider-help.joinuplift.co/en_us/uplift-formulary-SJlvi1o2ll',
  },
  {
    title: 'Prescribing Policy',
    description: 'Controlled substance and Rx requirements.',
    icon: PolicyOutlined,
    href: 'https://provider-help.joinuplift.co/en_us/prescribing-policy-r1dz3ZxClg',
  },
];

const PROVIDER_HELP_CENTER_URL = 'https://joinuplift1.kustomer.help/';

export const SupportPage = () => {
  const l10n = useL10n();
  const me = useCurrentuser();

  const tiles = useMemo(() => {
    const documentationGuideHref = me.medicalRole === ProviderMedicalRole.psychiatrist
      ? PSYCHIATRY_DOCUMENTATION_GUIDE_URL
      : THERAPY_DOCUMENTATION_GUIDE_URL;

    return getProviderTiles(documentationGuideHref);
  }, [ me.medicalRole ]);

  return (
    <ProviderLayout>
      <ProviderLayoutPageHeader
        title={(
          <Box>
            <ProviderLayoutPageTitle title={l10n.support.pageTitle} />
            <Typography variant="body1" color="textSecondary">
              {l10n.support.pageSubtitle}
            </Typography>
          </Box>
        )}
      />
      <HelpCenterContainer
        tiles={tiles}
        helpCenterUrl={PROVIDER_HELP_CENTER_URL}
      />
    </ProviderLayout>
  );
};
